export const bulkImportType = {
  CREATE: '新規登録',
  DELETE: '削除',
} as const;

export type BulkImportTypeKey = keyof typeof bulkImportType;

export const bulkImportTypeKeys = Object.keys(bulkImportType) as BulkImportTypeKey[];

/** v-select用items */
export const bulkImportTypeItems = bulkImportTypeKeys
  .map((key) => ({
    title: bulkImportType[key],
    value: key,
  }));
